import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import 'moment-timezone';
import { format } from 'date-fns';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Accordion,Card,Tab,Nav} from 'react-bootstrap';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import { ROUTE_CLIENT_TIMESHEET,SCHEDULE_CREW_STATUS,ENUM_SCHEDULE_CREW_STATUS,ROUTE_AFFILIATE_TIMESHEET,ROUTE_AFFILIATE_TIMESHEET_CREW_BASED,ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, PAGENUMROWS_AFFILIATE,PAGING_END_INDEX,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,ENUM_SHIFT_LENGTH_HHMM,SHIFT_LENGTH_MAX_HRS} from '../../configs/staticConfigs';
import { MSG_SAVE_TIMESHEET_WITH_INVOICE_SENT,MSG_TIMESHEET_CSV_ERROR,MSG_REQUIRED, MSG_NOT_FOUND,MSG_TIMESHEET_UPDATED,MSG_TIMESHEET_TOTAL_HOURS_LESS, MSG_OT_MAX_HOURS_ERROR } from '../../configs/msgConfigs';
import { LBL_REJECT,LBL_VIEW_TIMESHEET,LBL_EDIT,LBL_VIEW,LBL_OE_DETAILS,LBL_OT_APPROVED,LBL_INVOICE_SENT,LBL_FILE,LBL_APPROVE,LBL_DESCRIPTION,LBL_AMOUNT,LBL_OTHER_EXP,LBL_TOTAL_SHIFTS,LBL_DOWNLOAD_DETAILS,LBL_DOWNLOAD_SUMMARY,LBL_OTHER,LBL_OTHER_EXPENSES,LBL_OT_CHARGE_RATE_TOTAL,LBL_OT_CHARGE_RATE_PER_HOUR,LBL_OT_PAY_RATE_TOTAL,LBL_OT_PAY_RATE_PER_HOUR,LBL_CHARGE_RATE_TOTAL,LBL_CHARGE_RATE_PER_HOUR,LBL_PAY_RATE_TOTAL,LBL_PAY_RATE_PER_HOUR,LBL_OVER_TIME_HOURS,LBL_SHIFT_LENGTH_HOURS,LBL_CHECKOUT_DATE_TIME,LBL_CHECKIN_DATE_TIME,LBL_SHIFT_AND_SKILL,LBL_EVENT,LBL_EDIT_TIMESHEET,LBL_APPROVE_TIMESHEET,LBL_GROUP_CREW,LBL_GROUP_SHIFT,LBL_GROUP_BY,LBL_APP_NAME, LBL_TIMESHEET, LBL_SELECT, LBL_LIST_ALL, LBL_ACTION_NEEDED, LBL_FILTER, LBL_DOWNLOAD,LBL_SLNUM, LBL_PERSON, LBL_EVENT_TITLE, LBL_SHIFT, LBL_LOCATION, LBL_START_CHECKIN_TIME, LBL_END_CHECKOUT_TIME, LBL_SCHEDULED_HRS, LBL_ACTUAL_HRS, LBL_OT_HRS, LBL_APPROVAL_STATUS, LBL_CREW_NAME, LBL_CLEAR_FILTERS,  LBL_SHIFT_TOTAL_TRAVEL_COST, LBL_DRIVER_PAY_RATE, LBL_PASSENGER_PAY_RATE } from '../../configs/labelConfigs';

import {timesheetSummaryCSVDownloadAction,setActionNeeded,timesheetCSVDownloadAction,timesheetListAction,timesheetDetailsAction,timesheetUpdateAction} from '../../actions/timesheetActions';
import * as types from '../../actions';
import {otherExpListAction} from '../../actions/settings/otherExpActions';

import {serverTimeAction,timeSheetDateHeader} from  '../../actions/commonActions';
import {formValid,decimalNumRegex,checkNumDotZero} from '../../utils/validation';
import { converDateToLocal,convertDecimalToHHMM,convertHHMMToDecimal } from '../../utils/commonUtilities';

import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import { showStaffPayDetails } from '../commons/timesheetUtilities';  

import FilterTimesheet from './filterTimesheet';
import {format as stringFormat} from 'react-string-format';
import CustomMultiSelect from '../commons/helpers/customMultiSelect';
import FileIcon, { defaultStyles } from 'react-file-icon';

class TimeSheetCrewBased extends Component {

   constructor(props){
      super(props)

      this.state = {
         sentInvoice:false,
         enableApprove:false,
         otherExpenseData:{},
         viewHeading:false,
         selectCrewProfileId:null,
         crewBased:true,
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         activeRowId:0,    
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'-created_on',
         sortOrder:'', 
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         searchString:'',
         defaultStartDate:'',    
         defaultEndDate:'',    
         formErrors:{            
            overTimeHours:'',
            startTime:'',
            endTime:'',
            ratePerHour:'',
            totalHours:'',
            over_time_pay_rate: '', 
            over_time_pay_total: '', 
            over_time_charge_rate: '', 
            over_time_charge_total: '',
            pay_rate: '', 
            pay_total: '', 
            charge_rate: '', 
            charge_total: '',
            otherExpCost:'',
            otherExpenseData:{},
            driver_pay_rate: '',
            passenger_pay_rate: '', 
         },          
         timesheetData:{
            event: '',
            shift:'',
            person:'',
            location:'',
            shiftLength:'00:00',
            overTimeHours:'00:00',
            startDate:'',
            endDate:'',
            startTime:'',
            endTime:'',
            ratePerHour:0,
            over_time_pay_rate: 0.00, 
            over_time_pay_total: 0.00, 
            over_time_charge_rate: 0.00, 
            over_time_charge_total: 0.00,
            pay_rate: 0.00, 
            pay_total: 0.00, 
            charge_rate: 0.00, 
            charge_total: 0.00,
            otherExpCost: 0.00,
            total_travel_cost: 0.00, 
            driver_pay_rate: 0.00,
            passenger_pay_rate: 0.00,
         },   
         timesheetShiftList:[],
         selectedTimesheetId:0,
         approvedEventStatus:true,
         actionNeeded:true,
         otLengthError: '',
         noRowsError: '',
         isFilterOn: false,
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},
         isClientPage:false,
         clientId:0,
         exportTimesheet: [],
         markAbsentChecked: false,
         crew_id: '',
         showOverTimeData: false, 
         showOtherExpenseData: false, 
         otherExpMultiListMaster:[],
         otherExpMultiListStaff:[],
         selectedOtherExpObj: [],
         selectedStartDate: '',
         selectedEndDate: '',
      }

      this.onShowActionButtons = this.onShowActionButtons.bind(this);
      this.onHideActionButtons = this.onHideActionButtons.bind(this);
      this.modal = React.createRef();
      this.modalMarkAbsent = React.createRef();
   }

   setSelectedDate = (selectedStartDate,selectedEndDate) =>{
      this.setState({selectedStartDate : new Date(selectedStartDate),selectedEndDate : new Date(selectedEndDate)})
   }

   onResetFiltersButton = () => {   
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
          this.setState({resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-created_on', searchQuote:'',selectedStartDate:this.state.defaultStartDate,
            selectedEndDate:this.state.defaultEndDate}, () => {
            this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded});
              
              if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
              }
              else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
              }
          });
      }
      else {
          this.setState({resetFilterClicked,applyFilter:0,
            selectedStartDate:this.state.defaultStartDate,
            selectedEndDate:this.state.defaultEndDate,
         }); 
      }
   }

   onApplyFilterButton = () => {
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let applyFilter = 0; 
      if(filtersData.filtersSelected > 0) applyFilter = 1; 
      let sortOrder = ''; 
      let sortField = '-created_on'; 
      // if(filtersData.selectedStartDate!==0) sortField = '-start_date'; 
      this.setState({activePage:1, sortOrder:sortOrder, sortField:sortField, applyFilter:applyFilter, filtersData:filtersData}, () => { 
         this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:applyFilter,filtersData:filtersData}); 
      }); 
  }

   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');
   }

   onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }        
      
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }  

   

onSaveFormData = (timesheetId) =>{
      let timeZone = getUserTimeZone(this.props.location);
      let timeZoneOffSet = timeZone.utc_offset; 
      let {formErrors} = this.state;
      const {timesheetData, approvedEventStatus} = this.state;
      let error = false;
      for(let j in formErrors.otherExpenseData){
         if(formErrors.otherExpenseData[j]){
            error = true;
            break;
         }
      }

      if(formValid(this.state) && !error){  
         let overTimeHours = convertHHMMToDecimal(timesheetData.overTimeHours); 

        if(timesheetData.overTimeHours.trim()==='' || !overTimeHours){
            formErrors.overTimeHours = MSG_REQUIRED;
        } 
        else if(parseFloat(timesheetData.overTimeHours) > parseFloat(SHIFT_LENGTH_MAX_HRS)) {
            formErrors.overTimeHours = MSG_REQUIRED;
            this.setState({formErrors,otLengthError:MSG_OT_MAX_HOURS_ERROR});
        }
        else if(timesheetData.total_travel_cost < (timesheetData.driver_pay_rate+timesheetData.passenger_pay_rate)) {
            formErrors.driver_pay_rate = MSG_REQUIRED;
            formErrors.passenger_pay_rate = MSG_REQUIRED;
            this.setState({formErrors});
         }
        else {
            let fromMomentObj = moment(timesheetData.startDate + timesheetData.startTime, 'YYYY-MM-DDLT');
            let toMomentObj = moment(timesheetData.endDate + timesheetData.endTime, 'YYYY-MM-DDLT');
            let fromTime = '';
            let toTime = '';

            if(fromMomentObj.isValid()){
               fromTime = fromMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;
            }else{           
               let fromFormat = moment(timesheetData.startDate).format('YYYY-MM-DD');
               let fromMomentObj = moment(fromFormat + timesheetData.startTime, 'YYYY-MM-DDLT');
               fromTime = fromMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;
            }

            if(toMomentObj.isValid()){
               toTime  = toMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;         
            }else{
               let toFormat = moment(timesheetData.endDate).format('YYYY-MM-DD');
               let toMomentObj = moment(toFormat + timesheetData.endTime, 'YYYY-MM-DDLT');
               toTime = toMomentObj.format('YYYY-MM-DDTHH:mm:ss')+timeZoneOffSet;
            }  

            // OTHER EXPENSE DATA 
            // let otherExpData = this.state.selectedOtherExpObj; 
            let otherExpData = this.state.otherExpenseData; 
            let expensesObj = []; 
            let otherExpObj = {}; 
             Object.keys(otherExpData).map((staffItem,index) => {
               if(staffItem !== LBL_OTHER){
                  staffItem = Number(staffItem);
               }
               if(otherExpData[staffItem].amount && Number(otherExpData[staffItem].amount) > 0) { 
                  otherExpObj = {}; 
                  if(staffItem===LBL_OTHER) { // OTHER 
                     otherExpObj = {
                        "id": otherExpData[staffItem].masterId,
                        "expense": null, 
                        "other": LBL_OTHER,
                        "amount": otherExpData[staffItem].amount,
                        "description": otherExpData[staffItem].desc,
                        "approved": otherExpData[staffItem].approve,
                     }; 
                  }
                  else {
                     otherExpObj = {
                        "id": otherExpData[staffItem].masterId,
                        "expense": {
                           "id": staffItem,
                           "name": ""
                        }, 
                        "other": null, 
                        "amount": otherExpData[staffItem].amount,
                        "description": otherExpData[staffItem].desc,
                        "approved": otherExpData[staffItem].approve,
                     }; 
                  }
                  expensesObj.push(otherExpObj); 
               }
            })
            
            let data= {
               over_time: overTimeHours,
               over_time_pay_rate: Number(timesheetData.over_time_pay_rate),
               pay_rate: Number(timesheetData.pay_rate),
               pay_total: Number(timesheetData.pay_total),
               over_time_charge_rate: Number(timesheetData.over_time_charge_rate),
               charge_rate: Number(timesheetData.charge_rate),
               charge_total: Number(timesheetData.charge_total),
               from_time:fromTime,
               to_time:toTime, 
               over_time_approval_status: approvedEventStatus,
               id:timesheetId,
               absent:this.state.markAbsentChecked,
               expenses: expensesObj,
               driver_pay_rate: Number(timesheetData.driver_pay_rate),
               passenger_pay_rate: Number(timesheetData.passenger_pay_rate),
            }
            this.props.timesheetUpdateAction(data);
         }
      }else{
         if(timesheetData.overTimeHours===''){
            formErrors.overTimeHours = MSG_REQUIRED;
         } 
         if(timesheetData.over_time_pay_rate===''){
            formErrors.over_time_pay_rate = MSG_REQUIRED;
         } 
         if(timesheetData.over_time_charge_rate===''){
            formErrors.over_time_charge_rate = MSG_REQUIRED;
         }
         if(timesheetData.pay_rate===''){
            formErrors.pay_rate = MSG_REQUIRED;
         } 
         if(timesheetData.charge_rate===''){
            formErrors.charge_rate = MSG_REQUIRED;
         } 
         if(timesheetData?.total_travel_cost && timesheetData?.total_travel_cost > 0) {
            if(timesheetData.driver_pay_rate===''){
               formErrors.driver_pay_rate = MSG_REQUIRED;
            } 
            if(timesheetData.passenger_pay_rate===''){
               formErrors.passenger_pay_rate = MSG_REQUIRED;  
            } 
         } 
         this.setState({formErrors});
      }
   }   

   justClick = () => {

   }

   editBtnClick = (e,itemId,timesheetId,crew_profile_id,type,invoice_sent) =>{
       
      let timesheetData = this.state.timesheetData;
      let timesheet = this.state.timesheetShiftList;
      let selectedShift = {};
      let selectedCrewDet= {}; 
      this.modal.current.handleOpenModal();
      timesheet.forEach(item => {
            if(Number(item.crew_profile_id) === Number(crew_profile_id)){
               selectedShift = item.shift;
               selectedShift.forEach(crewDet => { 
                  if(Number(crewDet.id) === Number(timesheetId)){
                     selectedCrewDet = crewDet
                  }
               })
               
            }
         });

      timesheetData['markAbsentStatus'] = selectedCrewDet.schedule_status == ENUM_SCHEDULE_CREW_STATUS.NOT_CHECKEDIN ? true : false;
      timesheetData['scheduleID'] = selectedCrewDet.schedule_id;
      timesheetData['event'] = selectedCrewDet.event_title;
      timesheetData['shift'] = selectedCrewDet.shift_title; //+' - '+selectedShift.skill_name;
      timesheetData['location'] = selectedCrewDet.shift_location[0].location.venue;

      // CONVERT DATE AND TIME TO TIMEZONE OF USER'S SETTING  
      let timeZone = getUserTimeZone(this.props.location); // TAKE TIME ZONE OF USER 
      let sDate = converDateToLocal(selectedCrewDet.checkin_datetime,timeZone.utc_offset,'yyyymmddThhmmss','-'); 
      let eDate = converDateToLocal(selectedCrewDet.checkout_datetime,timeZone.utc_offset,'yyyymmddThhmmss','-');
      let arrTime = []; 
      arrTime = sDate.split('T'); 
      let sTime = arrTime[1].substring(0,5); 
      arrTime = eDate.split('T');
      let eTime = arrTime[1].substring(0,5); 
      let overTimeHours = convertDecimalToHHMM(selectedCrewDet.over_time); 
      let scheduled_hours = convertDecimalToHHMM(selectedCrewDet.scheduled_hours); 

      timesheetData['person'] = selectedCrewDet.crew_name;
      timesheetData['shiftLength'] = scheduled_hours; 
      timesheetData['overTimeHours'] = overTimeHours; 
      timesheetData['startDate'] = sDate;
      timesheetData['endDate'] = eDate;
      timesheetData['startTime'] = sTime; 
      timesheetData['endTime'] = eTime;
      // timesheetData['ratePerHour'] = selectedCrewDet.over_time_pay_rate ? selectedCrewDet.over_time_pay_rate : 0;

      // IF OVERTIME AND OVERTIMEPAYRATE HAS VALUE BUT OVERTIMEPAYTOAL IS ZERO, THEN CALCULATE IT
      //  over_time over_time_pay_rate over_time_pay_total
      let oT = parseFloat(selectedCrewDet.over_time); 

      let oTPayRate = selectedCrewDet.over_time_pay_rate ? parseFloat(selectedCrewDet.over_time_pay_rate) : 0; 
      let oTPayTot  = selectedCrewDet.over_time_pay_total ? parseFloat(selectedCrewDet.over_time_pay_total) : 0;
      if(oT > 0 && oTPayRate > 0 && oTPayTot===0) {
         oTPayTot  = parseFloat(oT*oTPayRate).toFixed(2)
      } 

      let oTChargeRate = selectedCrewDet.over_time_charge_rate ? parseFloat(selectedCrewDet.over_time_charge_rate) : 0; 
      let oTChargeTot  = selectedCrewDet.over_time_charge_total ? parseFloat(selectedCrewDet.over_time_charge_total) : 0;
      if(oT > 0 && oTChargeRate > 0 && oTChargeTot===0) {
         oTChargeTot  = parseFloat(oT*oTChargeRate).toFixed(2)
      }

      let payRate = selectedCrewDet.pay_rate ? parseFloat(selectedCrewDet.pay_rate) : 0; 
      let payTot  = selectedCrewDet.pay_total ? parseFloat(selectedCrewDet.pay_total) : 0;

      let chargeRate = selectedCrewDet.charge_rate ? parseFloat(selectedCrewDet.charge_rate) : 0; 
      let chargeTot  = selectedCrewDet.charge_total ? parseFloat(selectedCrewDet.charge_total) : 0;

      timesheetData['over_time_pay_rate']    = parseFloat(oTPayRate).toFixed(2);
      timesheetData['over_time_charge_rate'] = parseFloat(oTChargeRate).toFixed(2);
      timesheetData['over_time_pay_total']   = parseFloat(oTPayTot).toFixed(2);
      timesheetData['over_time_charge_total']= parseFloat(oTChargeTot).toFixed(2);

      timesheetData['pay_rate']    = parseFloat(payRate).toFixed(2);
      timesheetData['charge_rate'] = parseFloat(chargeRate).toFixed(2);
      timesheetData['pay_total']   = parseFloat(payTot).toFixed(2);
      timesheetData['charge_total']= parseFloat(chargeTot).toFixed(2);

      timesheetData['total_travel_cost']     = selectedCrewDet?.total_travel_cost ? parseFloat(selectedCrewDet.total_travel_cost).toFixed(2) : 0.00;
      timesheetData['driver_pay_rate']       = selectedCrewDet?.driver_pay_rate ? parseFloat(selectedCrewDet.driver_pay_rate).toFixed(2) : 0.00;
      timesheetData['passenger_pay_rate']    = selectedCrewDet?.passenger_pay_rate ? parseFloat(selectedCrewDet.passenger_pay_rate).toFixed(2) : 0.00;

      if(overTimeHours === '00:00' || overTimeHours===''){
         this.setState({enableApprove:false})
      }else{
         this.setState({enableApprove:true})
      }

      // OTHER EXPENSES 
      let otherExpObj = []; 
      this.setState({otherExpenseData:{},viewHeading:type},()=>{
         if(selectedCrewDet.expenses && Array.isArray(selectedCrewDet.expenses) && selectedCrewDet.expenses.length) {
         otherExpObj = this.loadDataToMultiSelect(selectedCrewDet.expenses); 
         }
         else {
            otherExpObj = this.state.otherExpMultiListMaster; 
         }
         this.setState({sentInvoice:invoice_sent,selectCrewProfileId:crew_profile_id,timesheetData,selectedTimesheetId:timesheetId,approvedEventStatus:selectedCrewDet.over_time_approval_status,showOverTimeData:false,showOtherExpenseData:false,otherExpMultiListStaff:otherExpObj,selectedOtherExpObj:otherExpObj});
      })

      


   //    "id":480,"shift_id":1491,"event_id":670,"shift_start_time":"2020-09-19T01:00:00Z","shift_end_time":"2020-09-19T06:00:00Z","scheduled_hours":"5.00","crews":[{"crew_name":"CrewTen VJ","crew_id":262}],"shift_location":[{"id":189,"location":{"id":264,"location":"Baker Street Studios, 1-3 Baker St, Banksmeadow NSW 2019, Australia","venue":"Baker Street Studios","street1":"1-3, Baker Street","street2":"","city":"Banksmeadow, Bayside Council","state":"New South Wales","country":"Australia","postcode":"2019","lat_long":"-33.9432549,151.2171361"},"is_active":true,"affiliate":158}],
    
   //  "crew_details":[
   //      {"crew_name":"CrewTen VJ","crew_profile_id":262,"over_time_approval_status":false,"checkin_datetime":"2020-09-03T13:49:21.132807Z","checkout_datetime":"2020-09-03T13:49:26.920540Z","scheduled_hours":"5.00","actual_hours":"0.00","over_time":"0.00","timesheet_id":104,"profile_color":"#740f5d","over_time_pay_rate":"25.00","over_time_total_rate":0.0}]
   }   

   onStartDateChange = (date) =>{
      let {timesheetData} = this.state;
      let startDate = ''
      if(date==='' || date===null){
         startDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         startDate = format(new Date(date), 'yyyy-MM-dd');
      }
      timesheetData['startDate'] = startDate;
      timesheetData['endDate'] = startDate;
      this.setState({timesheetData});
      //Validation has been removed as per client request on 01 feb 2022
      // this.calculateMinimumHour();
   }



   onEndDateChange = (date) =>{    
      let {timesheetData} = this.state;  
      let endDate = ''
      if(date==='' || date===null){
         endDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         endDate = format(new Date(date), 'yyyy-MM-dd');
      }
      timesheetData['endDate'] = endDate;
      this.setState({timesheetData});
      //Validation has been removed as per client request on 01 feb 2022           
      // this.calculateMinimumHour();
   }

   onShiftStartDateChange = (date) =>{
      let {filtersData} = this.state;
      let startDate = ''
      if(date==='' || date===null){
         startDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         startDate = format(new Date(date), 'yyyy-MM-dd');
      }
      filtersData['shiftFromDate'] = startDate;
      filtersData['filtersSelected'] = 1;

      if(filtersData['shiftEndDate']){
         let endDate = new Date(filtersData['shiftEndDate'])
         let startDate = new Date(filtersData['shiftFromDate'])
         if(startDate > endDate){
            filtersData['shiftEndDate'] = filtersData['shiftFromDate'];
         }
         
      }
      
      this.setState({filtersData,selectedEndDate:new Date(filtersData['shiftEndDate']),selectedStartDate:new Date(filtersData['shiftFromDate'])},() =>{
            if(filtersData['shiftFromDate'] && filtersData['shiftEndDate']){
               this.applyFilters(filtersData);
            }
      });
      if(filtersData['shiftFromDate'] && filtersData['shiftEndDate'] && !this.state.actionNeeded){
         let shiftEndDate_header = format(new Date(filtersData['shiftEndDate']), 'dd/MM/yyyy');
         let shiftFromDate_header = format(new Date(filtersData['shiftFromDate']), 'dd/MM/yyyy');
         this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
      }
      
   }

   onShiftEndDateChange = (date) =>{    
      let {filtersData} = this.state;  
      let endDate = ''
      if(date==='' || date===null){
         endDate = format(new Date(), 'yyyy-MM-dd');
      }else{
         endDate = format(new Date(date), 'yyyy-MM-dd');
      }
      filtersData['shiftEndDate'] = endDate;
      filtersData['filtersSelected'] = 1;

      

      this.setState({filtersData,selectedEndDate:new Date(endDate)},() =>{
         if(filtersData['shiftFromDate'] && filtersData['shiftEndDate']){
            let endDate = new Date(filtersData['shiftEndDate'])
            let startDate = new Date(filtersData['shiftFromDate'])
            if(startDate <= endDate){
               this.applyFilters(filtersData);
            }
         }
      });
      if(filtersData['shiftFromDate'] && filtersData['shiftEndDate'] && !this.state.actionNeeded){
         let shiftEndDate_header = format(new Date(filtersData['shiftEndDate']), 'dd/MM/yyyy');
         let shiftFromDate_header = format(new Date(filtersData['shiftFromDate']), 'dd/MM/yyyy');
         this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
      }           
   }

   onHandleChangeStartTime = (time) =>{
      let {formErrors,timesheetData} = this.state;    
      if(time._d !== undefined){
         let startTime = format(new Date(time._d), 'HH:mm');           
         timesheetData['startTime'] = startTime;
         this.setState({timesheetData,formErrors});
         //Validation has been removed as per client request on 01 feb 2022
         // this.calculateMinimumHour();
      }           
   }  

   onHandleChangeEndTime = (time) =>{
      let {formErrors,timesheetData} = this.state;    
      if(time._d !== undefined){
         let startTime = format(new Date(time._d), 'HH:mm');           
         timesheetData['endTime'] = startTime;
         this.setState({timesheetData,formErrors});
         //Validation has been removed as per client request on 01 feb 2022
         // this.calculateMinimumHour();
      }           
   }  


   onBlurStartTime = (time) =>{
      let {formErrors, timesheetData} = this.state;
      if(time._d !== undefined){
         let startime = format(new Date(time._d), 'HH:mm');
         timesheetData['startTime'] = startime;
         formErrors.startTime = '';          
      }else{
         try{
               var d = new Date(),
                  s = time,
                  parts = s.match(/(\d+)\:(\d+)/),
                  hours = parseInt(parts[1], 10),
                  minutes = parseInt(parts[2], 10);

              d.setHours(hours);
              d.setMinutes(minutes);
              let startime = format(d, 'HH:mm');
              timesheetData['startTime'] = startime;
              formErrors.startTime = '';
         }catch(err) {
              formErrors.startTime = MSG_REQUIRED;                
         }          
      } 
      this.setState({timesheetData,formErrors});
   }

   onBlurEndTime = (time) =>{
      let {formErrors, timesheetData} = this.state;
      if(time._d !== undefined){
         let endTime = format(new Date(time._d), 'HH:mm');
         timesheetData['endTime'] = endTime;
         formErrors.endTime = '';          
      }else{
         try{
               var d = new Date(),
                  s = time,
                  parts = s.match(/(\d+)\:(\d+)/),
                  hours = parseInt(parts[1], 10),
                  minutes = parseInt(parts[2], 10);

              d.setHours(hours);
              d.setMinutes(minutes);
              let endTime = format(d, 'HH:mm');
              timesheetData['endTime'] = endTime;
              formErrors.endTime = '';
         }catch(err) {
              formErrors.endTime = MSG_REQUIRED;                
         }          
      } 
      this.setState({timesheetData,formErrors});
   }   

   calculateMinimumHour = ()=>{
      let {timesheetData,formErrors} = this.state;
      let totalHours = parseFloat(convertHHMMToDecimal(timesheetData.shiftLength))+parseFloat(convertHHMMToDecimal(timesheetData.overTimeHours));
      let fromMomentObj = moment(timesheetData.startDate + timesheetData.startTime, 'YYYY-MM-DDLT');
      let toMomentObj = moment(timesheetData.endDate + timesheetData.endTime, 'YYYY-MM-DDLT');

      let fromTime = '';
      let toTime = '';

      if(fromMomentObj.isValid()){
         fromTime = fromMomentObj.format('YYYY-MM-DD HH:mm:ss');
      }else{           
         let fromFormat = moment(timesheetData.startDate).format('YYYY-MM-DD');
         let fromMomentObj = moment(fromFormat + timesheetData.startTime, 'YYYY-MM-DDLT');
         fromTime = fromMomentObj.format('YYYY-MM-DD HH:mm:ss');
      }
      if(toMomentObj.isValid()){
         toTime  = toMomentObj.format('YYYY-MM-DD HH:mm:ss');         
      }else{
         let toFormat = moment(timesheetData.endDate).format('YYYY-MM-DD');
         let toMomentObj = moment(toFormat + timesheetData.endTime, 'YYYY-MM-DDLT');
         toTime = toMomentObj.format('YYYY-MM-DD HH:mm:ss');
      } 

      let diffObj    = moment.duration(moment(toTime).diff(moment(fromTime)));
      let difference = parseFloat(convertHHMMToDecimal(diffObj.asHours()+':'+Math.floor(diffObj.minutes())));
      if(difference<totalHours){
         formErrors['totalHours'] = MSG_TIMESHEET_TOTAL_HOURS_LESS;
      }else{
         formErrors['totalHours'] = '';
      }
      this.setState({formErrors});
   }

   onLoadShift = (e,crewId,isExpand)=>{
      if(!isExpand){
         this.props.timesheetDetailsAction({crewId:crewId,actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }else{
         let newTimesheetObj = {}
         let tempObj = this.state.timesheetShiftList;
         newTimesheetObj = tempObj.map(item => {
            if(item.crew_profile_id===crewId) {
               item['shift'] = [];
               item['isExpand'] = false;
            }
            return item;
         })
         this.setState({timesheetShiftList:newTimesheetObj});
      }
   }
   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      this.props.timesheetListAction({pageSize:this.state.perPageCount,page:previousPage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => {     

      this.props.timesheetListAction({pageSize:this.state.perPageCount,page:e.target.id,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});

      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      this.props.timesheetListAction({pageSize:this.state.perPageCount,page:nextPage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
          this.setState({ sortOrder:sOrder });            
      }else{
          this.setState({ sortField:sortKey });
          this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }        
   }

   onModalFormReset = () =>{      
      this.setState({
         timesheetId:'',
         formErrors:{
            overTimeHours:'',
            startTime:'',
            endTime:'',
            ratePerHour:'',
            totalHours:'',
            over_time_pay_rate: '',
            over_time_pay_total: '', 
            over_time_charge_rate: '', 
            over_time_charge_total: '',
            pay_rate: '',
            pay_total: '', 
            charge_rate: '', 
            charge_total: '',
            otherExpCost:'',
            otherExpenseData:{},
            driver_pay_rate: '',
            passenger_pay_rate: ''
         },
         approvedEventStatus:false,
         markAbsentChecked: false
      });
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   applySearch = (e)=>{
      let strVal = e.target.value; 
      this.setState({searchString:strVal}, () => {  
         if(strVal.length >=3 || strVal.length===0) {
            this.props.timesheetListAction({pageSize:this.state.perPageCount,page:1,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
         } 
      })
   }

   setToasterState(isEnabled,message,isSucces,ms=3000){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      setTimeout(()=> {
          this.onCloseToast();
      }, ms);
   }

   loadDataToMultiSelect(crewOtherExpData) {
      let masterList = [];
      let tmpList = this.state.otherExpMultiListMaster;
      let tmpObj = {}; 
      if(tmpList && Array.isArray(tmpList) && tmpList.length) {
         tmpList.forEach(item => {
            tmpObj = Object.assign({}, item); 
            masterList.push(tmpObj); 
         })
      } 
      // "expenses": [
      //     { "id":3, "expense":null, "other":"test", "amount":"15.00", "description":null },
      //     { "id":2, "other":null,  "amount":"10.00",  "description":null 
      //       "expense":
      //          { "id":24, "name":"Test Two", "short_description":"", "is_active":true, "affiliate":76 }, 
      //     }
      // ]
      if(crewOtherExpData.length){ 
         let otherExpenseData = this.state.otherExpenseData;
         crewOtherExpData.forEach(staffItem => {
            if(!staffItem.other || !staffItem.other.length) { // NORMAL OTHER EXPENSE ITEM FROM THE MASTER LIST 
               masterList.forEach(masterItem => {
                  if(Number(staffItem.expense.id)===Number(masterItem.value)) {
                     masterItem['masterId'] = staffItem.id ? staffItem.id : '';
                     masterItem['inputVal'] = staffItem.amount;
                     masterItem['inputValDescr'] = staffItem.description;
                     masterItem['reciepts'] = staffItem.reciepts;
                     otherExpenseData[masterItem.value] = {'select':true,
                                             'amount':Number(staffItem.amount),
                                             'desc':staffItem.description,
                                             'approve': staffItem.approved,
                                             'masterId': masterItem['masterId']

                                          }
                  }
               })
            }
            else { // OTHER 
               masterList.forEach(masterItem => {
                  if(masterItem.value===LBL_OTHER) {
                     masterItem['masterId'] = staffItem.id ? staffItem.id : '';
                     masterItem['inputVal'] = staffItem.amount;
                     masterItem['inputValDescr'] = staffItem.description;
                     masterItem['reciepts'] = staffItem.reciepts;
                     otherExpenseData[masterItem.value] = {'select':true,
                                             'amount':Number(staffItem.amount),
                                             'desc':staffItem.description,
                                             'approve': staffItem.approved,
                                             'masterId': masterItem['masterId']

                                          }
                  }
               })
            }
         });
         this.setState({otherExpenseData:otherExpenseData});
      }
      return(masterList)
   }

   formatOtherExpData(array){
      // IN OTHER EXPENSE ITEMS, IF 'Other' IS NOT THERE, ADD IT FROM FRONT-END 
      let foundOther = 0; 
      let otherExp = [];
      if(array.length>0){
          array.map(item => {
             if(item.name.trim().toLowerCase()===LBL_OTHER.trim().toLowerCase()) foundOther = 1; 
              let  expObj = {};
              expObj['masterId'] = '';
              expObj['value'] = item.id;
              expObj['label'] = item.name;
              expObj['info'] = item.short_description;
              expObj['inputVal'] = 0.00;
              expObj['inputValDescr'] = '';
              otherExp.push(expObj);
              return otherExp;
          });
      }
      //Removed Other
      // if(foundOther===0) {
      //    let  otherObj = {};
      //    otherObj['masterId'] = '';
      //    otherObj['value'] = LBL_OTHER;
      //    otherObj['label'] = LBL_OTHER;
      //    otherObj['info'] = LBL_OTHER;
      //    otherObj['inputVal'] = 0.00;
      //    otherObj['inputValDescr'] = '';
      //    otherExp.push(otherObj);
      // } 
      return otherExp;
   }

   onOtherExpDataChange = (selectedOtherExp) =>{  
      let staffData = this.state.otherExpMultiListStaff;
      let newSelArr = []; 
      if(!selectedOtherExp.length) {   
         this.setState({selectedOtherExpObj:[]}); 
      }
      else {
         let selObj = {};
         selectedOtherExp.forEach(selItem => { 
            selObj = selItem;
            selObj.masterId = ''; 
            staffData.forEach(staffItem => {
               if(selItem.value==staffItem.value) {
                  selObj.masterId      = staffItem.masterId;
               }
            }); 
            newSelArr.push(selObj); 
         })
         this.setState({selectedOtherExpObj:newSelArr}); 
      }
   }

   otherExpenseChange = (e,id,oValue,type) =>{
      // const value = e.target.type === "radio" ? type : e.target.value;
      const value = e.target.type === "radio" ? type : e.target.type === "checkbox"?e.target.checked:e.target.value;
      let {otherExpenseData,formErrors} = this.state;
      let selecteObjs = this.state.selectedOtherExpObj;
      const name = e.target.name.split('_')[0];

      if(name === 'select' && value){
         let staffData = this.state.otherExpMultiListStaff;
         let newSelArr = [];
         let selObj = {};
         staffData.forEach(staffItem => {
            if(oValue==staffItem.value) {
               selObj.masterId  = staffItem.masterId;
               selObj.value = oValue;
            }
         }); 
         newSelArr.push(selObj); 
         this.setState({selectedOtherExpObj:newSelArr}); 
         if(otherExpenseData[oValue]){
            otherExpenseData[oValue][name] = value;
         }else{
            otherExpenseData[oValue] = {[name]:value};
         }
         otherExpenseData[oValue].masterId = selObj.masterId  
         otherExpenseData[oValue].approve = 1;
         formErrors.otherExpenseData[oValue] = 'input-error';

      }else if(name === 'select' && !value){
         
         let filteredItem = selecteObjs.filter(item => item.value !== oValue);
         this.setState({selectedOtherExpObj:filteredItem});
         for(let i in otherExpenseData){
            if(oValue === LBL_OTHER){
               if(i === oValue){
                  delete otherExpenseData[oValue];
               }
            }
            else if(parseInt(i) === oValue){
               delete otherExpenseData[oValue];
            }
         }
         formErrors.otherExpenseData[oValue] = '';
      }else{
         if(otherExpenseData[oValue]){
            if(name === 'amount') { 
               if(value.trim().length && checkNumDotZero(value.trim())) {
                  otherExpenseData[oValue][name] = value;
               }
               else {
                  otherExpenseData[oValue][name] = '';
               }
            }
            else {
               otherExpenseData[oValue][name] = value;
            }
         }else{
            if(name === 'amount') { 
               if(value.trim().length && checkNumDotZero(value.trim())) { 
                  otherExpenseData[oValue] = {[name]:value};
               }
               else {
                  otherExpenseData[oValue] = {[name]:''};
               }
            }
            else {
               otherExpenseData[oValue] = {[name]:value};
            }
         }


         if(name === 'amount'){
            if(value.trim().length === 0 || isNaN(Number(value))){
               formErrors.otherExpenseData[oValue] = 'input-error';
            }else{
               formErrors.otherExpenseData[oValue] = '';
            }
            selecteObjs.forEach(item =>{
               if(item.value === oValue){
                  if(value.trim().length && checkNumDotZero(value.trim())) {
                     item.inputVal = value;
                  }
                  else {
                     item.inputVal = value;
                  }
               }
            })
         }else if(name === 'desc'){
            selecteObjs.forEach(item =>{
               if(item.value === oValue){
                  item.inputValDescr = value
               }
            })
         }else if(name === 'approve'){
            selecteObjs.forEach(item =>{
               if(item.value === oValue){
                  item.approved = value
               }
            })
         }
         this.setState({selectedOtherExpObj:selecteObjs});
      }
      
      this.setState({otherExpenseData:otherExpenseData,formErrors:formErrors})


   }

   setStateUpdate(numRows,totalPage,activity,errorData,timesheet,timesheetDetails,timesheetCSV,timesheetSummaryCSV){
      //let {timesheetShiftList} = this.state;
      let arrResp = activity ? activity.split('~~') : []; 
      let actString = arrResp[0] ? arrResp[0] : ''; 
      if(actString===types.TIMESHEET_CSV_DOWNLOAD_SUCCESS){ 
         const url = window.URL.createObjectURL(new Blob([timesheetCSV]));
         const link = document.createElement('a');
         link.href = url;
         if(this.state.actionNeeded){
            link.setAttribute('download', 'timesheet-details.csv'); //or any other extension
         }else{
            let fileName = '';
            if(this.state.selectedStartDate){
               fileName = 'timesheet-details-'+format(this.state.selectedStartDate, 'dd-MM-yyyy')+'_'+format(this.state.selectedEndDate, 'dd-MM-yyyy')+'.csv';
            }else{
               fileName = 'timesheet-details-'+format(this.state.defaultStartDate, 'dd-MM-yyyy')+'_'+format(this.state.defaultEndDate, 'dd-MM-yyyy')+'.csv';
            }
            link.setAttribute('download', fileName); //or any other extension
         }

         document.body.appendChild(link);
         link.click();
      }
      else if(actString===types.TIMESHEET_CSV_DOWNLOAD_ERROR){ 
         this.setToasterState(true,MSG_TIMESHEET_CSV_ERROR,false);
         // timesheetCSV 
      }
      if(actString===types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_SUCCESS){ 
         const url = window.URL.createObjectURL(new Blob([timesheetSummaryCSV]));
         const link = document.createElement('a');
         link.href = url;
         if(this.state.actionNeeded){
            link.setAttribute('download', 'timesheet-summary.csv'); //or any other extension
         }else{
            let fileName = '';
            if(this.state.selectedStartDate){
               fileName = 'timesheet-summary-'+format(this.state.selectedStartDate, 'dd-MM-yyyy')+'_'+format(this.state.selectedEndDate, 'dd-MM-yyyy')+'.csv';
            }else{
               fileName = 'timesheet-summary-'+format(this.state.defaultStartDate, 'dd-MM-yyyy')+'_'+format(this.state.defaultEndDate, 'dd-MM-yyyy')+'.csv';
            }
            link.setAttribute('download', fileName); //or any other extension
         }
         document.body.appendChild(link);
         link.click();
      }
      else if(actString===types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR){ 
         this.setToasterState(true,MSG_TIMESHEET_CSV_ERROR,false);
         // timesheetCSV 
      }

      if(actString===types.TIMESHEET_LIST_SUCCESS){  
         timesheet = timesheet.map(item => {
            item['isExpand'] = false;
            // item['shift'] = item.shift_details;
            return item;
         });
         this.setState({timesheetShiftList:timesheet},() =>{
            if(this.state.selectCrewProfileId){

               this.onLoadShift('',this.state.selectCrewProfileId,false);
               this.setState({selectCrewProfileId:null});
            }
            
         })
      }else if(actString===types.TIMESHEET_DETAILS_SUCCESS){  
         let errMsg = MSG_NOT_FOUND;
         let newTimesheetObj = {}
         let tempObj = this.state.timesheetShiftList;
         newTimesheetObj = tempObj.map(item => {
            if(timesheetDetails && item.crew_profile_id===timesheetDetails[0].crew_profile_id) {
               item['shift'] = timesheetDetails;
               item['isExpand'] = true;
            }
            errMsg = ''; 
            return item;
         })
         this.setState({timesheetShiftList:newTimesheetObj,noRowsError:errMsg});
      }else if(actString===types.TIMESHEET_DETAILS_ERROR){
         let errMsg = MSG_NOT_FOUND;
         this.setState({noRowsError:errMsg});
         this.setToasterState(true,JSON.stringify(errorData),false);
      }else if(actString===types.TIMESHEET_UPDATE_SUCCESS){
         if(this.state.sentInvoice){
            this.setToasterState(true,MSG_SAVE_TIMESHEET_WITH_INVOICE_SENT,true,6000);
            this.setState({sentInvoice:false});
         }else{
            this.setToasterState(true,MSG_TIMESHEET_UPDATED,true);
         }
         this.modal.current.handleModelClose(true);       
         this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }else if(actString===types.TIMESHEET_UPDATE_ERROR){
         this.setToasterState(true,JSON.stringify(errorData),false);
      }     
   } 
   onOtherExpDataChange = (selectedOtherExp) =>{  
      let staffData = this.state.otherExpMultiListStaff;
      let newSelArr = []; 
      if(!selectedOtherExp.length) {   
         this.setState({selectedOtherExpObj:[]}); 
      }
      else {
         let selObj = {};
         selectedOtherExp.forEach(selItem => { 
            selObj = selItem;
            selObj.masterId = ''; 
            staffData.forEach(staffItem => {
               if(selItem.value==staffItem.value) {
                  selObj.masterId      = staffItem.masterId;
               }
            }); 
            newSelArr.push(selObj); 
         })
         this.setState({selectedOtherExpObj:newSelArr}); 
      }
   }

   componentDidUpdate(prevProps) {
      const {serverTimeListActivity,subactivity,otherExps,isFilterOn,numRows,totalPage,activity,errorData,timesheet,timesheetDetails,timesheetCSV, timesheetSummaryCSV} = this.props;    
      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      }else if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData,timesheet,timesheetDetails,timesheetCSV,timesheetSummaryCSV);
      }

      if (subactivity !== prevProps.subactivity) {
         let arrSubResp = subactivity ? subactivity.split('~~') : []; 
         if(arrSubResp[0]===types.OTHER_EXP_LIST_SUCCESS){
            this.setState({otherExpMultiListMaster: this.formatOtherExpData(otherExps)}); 
            
         }
      } 
      if(serverTimeListActivity && (serverTimeListActivity !== prevProps.serverTimeListActivity || this.state.applyFilterClicked === 0)){
         let arrTimeResp = serverTimeListActivity.split('~~');
         if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
            // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
            let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
            let defaultStartDate = new Date();
            defaultStartDate = new Date(defaultStartDate.setDate(defaultEndDate.getDate() - 7));
            this.setState({defaultStartDate:defaultStartDate,defaultEndDate:defaultEndDate,applyFilterClicked:1,
               selectedStartDate:defaultStartDate,selectedEndDate:defaultEndDate})
            
         }
      }
   }

   componentDidMount() {
        this.setState({actionNeeded:this.props.getActionNeeded});
        const { location } = this.props;
      
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.props.otherExpListAction({page:0,column:'name',affiliateId:userGroupData.profile_id,shiftId:0});
            this.setState({isClientPage:false,clientId:0});     
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
            this.props.otherExpListAction({page:0,column:'name',affiliateId:userGroupData.client_default_affiliate_id,shiftId:0});
            this.setState({isClientPage:true, clientId:userGroupData.profile_id});  
        }
        document.title = LBL_APP_NAME+" - "+LBL_TIMESHEET;
        this.setState({actionNeeded:this.props.getActionNeeded},() =>{
         this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded});
         }) ;

         this.props.serverTimeAction(); 
         this.props.timeSheetDateHeader('');
        
   }  
   
   onChangeApproveOT = (e,value) =>{
      let {approvedEventStatus} = this.state;
      approvedEventStatus = value;
      this.setState({approvedEventStatus});
   }

   onTimeFilterToggle = (flag) =>{
      let {actionNeeded, approvedEventStatus} = this.state;
      actionNeeded = flag;
      if(flag){
         this.props.timeSheetDateHeader('')
      }else{
         this.props.serverTimeAction(); 
         if(this.state.selectedStartDate && this.state.selectedEndDate){
            let shiftFromDate_header = format(new Date(this.state.selectedStartDate), 'dd/MM/yyyy');
            let shiftEndDate_header = format(new Date(this.state.selectedEndDate), 'dd/MM/yyyy');
            this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
         }else{
            let shiftFromDate_header = format(new Date(this.state.defaultStartDate), 'dd/MM/yyyy');
            let shiftEndDate_header = format(new Date(this.state.defaultEndDate), 'dd/MM/yyyy');
            this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
         }
      }
      this.setState({actionNeeded,activePage:1}, () => { 
         this.props.setActionNeeded(actionNeeded);
         this.props.timesheetListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      });
   }

   onHandleChangeoverTimeHours = (time) =>{
      let {timesheetData,formErrors,otLengthError} = this.state; 
      let enableApprove = false;
      if(time._d !== undefined){
          let overTimeHours = format(new Date(time._d), 'HH:mm');           
          timesheetData['overTimeHours'] = overTimeHours;
          if(overTimeHours === '00:00'){
               enableApprove = false;
          }else{
               enableApprove = true;
          }
          timesheetData['over_time_pay_total'] = (parseFloat(convertHHMMToDecimal(overTimeHours))*parseFloat(timesheetData.over_time_pay_rate)).toFixed(2);
          timesheetData['over_time_charge_total'] = (parseFloat(convertHHMMToDecimal(overTimeHours))*parseFloat(timesheetData.over_time_charge_rate)).toFixed(2);
          formErrors.overTimeHours = ''; 
          otLengthError = ''; 
      }
      else {
         formErrors.overTimeHours = MSG_REQUIRED; 
      }
      this.setState({timesheetData,formErrors,otLengthError,enableApprove}); 
  }

   onHandleChange = (e) =>{
      const {name,value}  = e.target;   
      let {formErrors,timesheetData} = this.state;
      let valStr = value.trim(); 
      let rateVal = valStr; 
      switch(name){ 
         case 'over_time_pay_rate':
            formErrors.over_time_pay_rate = value.length <=0 || decimalNumRegex.test(value) === false
            ? MSG_REQUIRED : ""; 
            if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
               valStr = '';
               rateVal = 0;  
               timesheetData['over_time_pay_total'] = 0; 
            }
            else { 
               timesheetData['over_time_pay_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.overTimeHours))*parseFloat(rateVal)).toFixed(2);
               
            }
            break;
         case 'over_time_charge_rate':
            formErrors.over_time_charge_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
            if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
               valStr = '';
               rateVal = 0;
               timesheetData['over_time_charge_total'] = 0; 
            }
            else { 
               timesheetData['over_time_charge_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.overTimeHours))*parseFloat(rateVal)).toFixed(2);
            }
            break;
         case 'pay_rate':
            formErrors.pay_rate = value.length <=0 || decimalNumRegex.test(value) === false
            ? MSG_REQUIRED : ""; 
            if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
               valStr = '';
               rateVal = 0;
               timesheetData['pay_total'] = 0; 
            }
            else { 
               timesheetData['pay_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.shiftLength))*parseFloat(rateVal)).toFixed(2);
            }
            break;
         case 'charge_rate':
            formErrors.charge_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
            if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
               valStr = '';
               rateVal = 0;
               timesheetData['charge_total'] = 0; 
            }
            else { 
               timesheetData['charge_total'] = (parseFloat(convertHHMMToDecimal(timesheetData.shiftLength))*parseFloat(rateVal)).toFixed(2);
            }
            break;  
         
         case 'driver_pay_rate':
            formErrors.driver_pay_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
            if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
               valStr = '';
               rateVal = 0;
               timesheetData['driver_pay_rate'] = 0; 
            }
            else { 
               timesheetData['driver_pay_rate'] = parseFloat(valStr);
            }
            break; 
         
         case 'passenger_pay_rate':
            formErrors.passenger_pay_rate = value.length <=0 || decimalNumRegex.test(value) === false ? MSG_REQUIRED : ""; 
            if(!valStr || valStr == '' || !checkNumDotZero(valStr)) { 
               valStr = '';
               rateVal = 0;
               timesheetData['passenger_pay_rate'] = 0; 
            }
            else { 
               timesheetData['passenger_pay_rate'] = parseFloat(valStr);
            }
            break; 

         default :
         break;
      }
      timesheetData[name] = valStr;
      
      this.setState({formErrors,timesheetData});
   } 

   convertMinsToHrsMins(mins) {
      let h = Math.floor(mins / 60);
      let m = mins % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return `${h}:${m}`;
   }
   changeCrewBasedState = () =>{
      let actionNeeded = this.state.actionNeeded;
      this.props.setActionNeeded(actionNeeded);
      this.setState({crewBased:false});
   }
   onDownloadTimesheet = () => {
      this.props.timesheetCSVDownloadAction({page:0,pageSize:0,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,csvDownload:1,crewBased:true});
   }

   onDownloadTimesheetSummary = () => {
      this.props.timesheetSummaryCSVDownloadAction({page:0,pageSize:0,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),actionNeeded:this.state.actionNeeded,applyFilter:this.state.applyFilter,filtersData:this.state.filtersData,csvDownload:1,crewBased:true});
   }

   accordionChange = (e,actionType) => {
      if(actionType==='overtime') { 
         let showVar = !this.state.showOverTimeData;
         this.setState({showOverTimeData:showVar}); 
      }
      else if(actionType==='otherexpense') { 
         let showVar = !this.state.showOtherExpenseData;
         this.setState({showOtherExpenseData:showVar}); 
      }
   }

   openConfirmModal = (timesheetId) => {
      if(this.state.markAbsentChecked){
         this.modalMarkAbsent.current.handleOpenModal();
      }else{
         this.onSaveFormData(timesheetId);
      }
   }
   setSelectCrewProfileId = (value) =>{
      this.setState({selectCrewProfileId:value});
   }
   
   render(){

      const {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,timesheetData,timesheetShiftList,formErrors,selectedTimesheetId,approvedEventStatus,actionNeeded,searchString,otherExpMultiListStaff         
     } = this.state  

      const {totalPage,status } = this.props; 

      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      let profileCurrency = '';
      let supervisor = '';
      let lblCrew = 'Staff';
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
         profileCurrency = userGroupData.profile_currency; 
         supervisor = userGroupData.supervisor_name; 
         if(userGroupData.staff_name){
            lblCrew = userGroupData.staff_name; 
         }
      }
      let lblCrewName = stringFormat('{0} Name',lblCrew);
      let lblCrewPay = stringFormat('{0} Pay',lblCrew)
      if(status===401 || status===403){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
         }else{
            return <Redirect to={ROUTE_REFRESH} />;
         }
      }  

      let selectedStartDate = '';
      let selectedEndDate = '';
      if(timesheetData.startDate !== ''){
          selectedStartDate = new Date(timesheetData.startDate);           
      }
      if(timesheetData.endDate!==''){
          selectedEndDate = new Date(timesheetData.endDate);
      } 

      let headers = [];
      let exportTimesheet = [];
      let exportTimesheetSummary = [];
      let timeZone =  getUserTimeZone(this.props.location);
      let selectedoverTimeHours = '00:00'; 
      if(this.state.crewBased === false){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_TIMESHEET}/>
         }
         else{
            return <Redirect to={ROUTE_CLIENT_TIMESHEET}/>
         }
      }

      return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
               <div className="box">
                  <div className="box-head overflow-visible-imp" >
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={LBL_CREW_NAME+'/'+LBL_EVENT_TITLE} id="my-search-input" onChange={this.applySearch} value={searchString} /></label>
                     </div>

                     { !actionNeeded && 
                     <>
                     <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER}
                          </Tooltip>}
                        >
                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                            
                        </OverlayTrigger>
                        
                     </div>
                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>} 
                     </>} 
                           

                     <div className="btn-group btn-group-sm to-right toggle-view padding-right-15">
                          <OverlayTrigger
                              placement="top"
                              delay={{ show: 450, hide: 250 }}
                              overlay={<Tooltip id="list-tooltip" style={{
                                  opacity: 0.4,
                                }}>
                              {LBL_ACTION_NEEDED}
                          </Tooltip>}
                          > 
                              <Link className={actionNeeded?'btn btn-outline-primary active':'btn btn-outline-primary'} to="#" onClick={(e) =>this.onTimeFilterToggle(true)}>
                              <i className="las la-hand-pointer"></i> </Link>
                          </OverlayTrigger>
                          <OverlayTrigger
                              placement="top"
                              delay={{ show: 450, hide: 250 }}
                              overlay={<Tooltip id="calendar-tooltip" style={{
                                  opacity: 0.4,
                                }}>
                              {LBL_LIST_ALL} 
                          </Tooltip>}
                          >
                              <Link className={!actionNeeded?'btn btn-outline-primary active':'btn btn-outline-primary'} to="#" onClick={(e) =>this.onTimeFilterToggle(false)}>
                              <i className="las la-list-alt"></i>  </Link>
                          </OverlayTrigger>
                      </div>   
                     <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                        {Array.isArray(timesheetShiftList) && timesheetShiftList.length > 0 && <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="download-tooltip" style={{
                           opacity: 0.4,
                        }}>
                        {LBL_DOWNLOAD_DETAILS}
                        </Tooltip>}
                        >
                           <Link className={'btn btn-outline-primary filter-btn'} to="#" onClick={(e) =>this.onDownloadTimesheet()}><i className="las la-file-download"></i></Link>  
                        </OverlayTrigger>}                   
                     </div>
                     {exportTimesheet.length > 0 && <CSVLink className="hidden" data={exportTimesheet} headers={headers} filename= {"timesheet-details.csv"}><i className="las la-file-download"></i></CSVLink>} 
                     <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                        {Array.isArray(timesheetShiftList) && timesheetShiftList.length > 0 && <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="download-tooltip" style={{
                           opacity: 0.4,
                        }}>
                        {LBL_DOWNLOAD_SUMMARY}
                        </Tooltip>}
                        >
                           <Link className={'btn btn-outline-primary filter-btn'} to="#" onClick={(e) =>this.onDownloadTimesheetSummary()}><i className="las la-file-invoice"></i></Link>  
                        </OverlayTrigger>}                   
                     </div>
                     {exportTimesheetSummary.length > 0 && <CSVLink className="hidden" data={exportTimesheetSummary} headers={headers} filename= {"timesheet-summary.csv"}><i className="las la-file-download"></i></CSVLink>}   
                     <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                        <OverlayTrigger
                           placement="top"
                           delay={{ show: 250, hide: 400 }}
                           overlay={<Tooltip id="download-tooltip" style={{
                              opacity: 0.4,
                           }}>
                           {LBL_GROUP_BY}
                           </Tooltip>}
                           >

                           <div className="groupBy-input">
                              <div className="form-group select-input">
                                 <select name="crewBasedOption" onChange={this.changeCrewBasedState} value={'0'} className={'groupBy'}  tabIndex="1" >
                                 <option key="0" value="0">{stringFormat(LBL_GROUP_CREW,lblCrew)}</option>
                                 <option key="1" value="1">{LBL_GROUP_SHIFT}</option>
                                 
                                 </select>
                              </div> 
                          </div>  

                           {/*<Link className="dropdown-item edit" to="#" onClick={this.changeCrewBasedState}>{LBL_GROUP_SHIFT}</Link>*/} 
                           </OverlayTrigger>
                     </div>
                     {!actionNeeded && 
                        <div className={"to-right dateFilter"}>
                           <div className={"cal-3"}>
                                <div className="form-group">
                                    <div className={'calendar-input'}>
                                        <DatePicker 
                                            onChange={selected =>this.onShiftStartDateChange(selected)}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Shift Start Date"
                                            fixedHeight          
                                            className={formErrors.startDate ? "input-error" : ''}
                                            selected={this.state.selectedStartDate?this.state.selectedStartDate:this.state.defaultStartDate}
                                            placeHolderTextStyle={{ color: '#d3d3d3' }}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={"cal-3"}>
                                <div className="form-group">
                                    <div className={'calendar-input'}>
                                            <DatePicker 
                                                selected={this.state.selectedEndDate?this.state.selectedEndDate:this.state.defaultEndDate}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Shift End Date"
                                                minDate={this.state.selectedStartDate} 
                                                fixedHeight       
                                                onChange={selected =>this.onShiftEndDateChange(selected)}                       
                                            />
                                    </div>
                                </div>
                            </div> 
                        </div>}                             
                  </div>
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th></th>
                                 <th>{LBL_SLNUM}</th>                                
                                 <th></th>                                
                                 <th>{LBL_PERSON}</th>
                                 {/*<th onClick={(e) => this.onSort(e,'user__email')} className="sorting_asc user-doc">{LBL_SHIFT+' / '+LBL_EVENT_TITLE}</th>*/}
                                 <th>{LBL_LOCATION}</th>
                                 <th>{LBL_START_CHECKIN_TIME} </th>
                                 <th>{LBL_END_CHECKOUT_TIME}  </th>
                                 <th>{LBL_TOTAL_SHIFTS}  </th>
                                 <th className={this.state.isClientPage ? "hide" : "text-right min-width-150"}>{lblCrewPay} ({profileCurrency})</th>
                                 <th className="text-center">{LBL_SCHEDULED_HRS} </th>
                                 {/*<th className="text-center">{LBL_ACTUAL_HRS} </th>*/}
                                 <th className="text-center">{LBL_OT_HRS} </th>
                                 <th className="text-center">{LBL_OE_DETAILS} </th>
                                 {/*<th className="text-center">{LBL_INVOICE_SENT} </th>*/}
                                 <th className="action">&nbsp;</th>
                              </tr>  
                           </thead>
                           <tbody>
                           {!timesheetShiftList || !Array.isArray(timesheetShiftList) || timesheetShiftList.length===0  && 
                                <tr>
                                    <td colSpan="13" className="text-center">{MSG_NOT_FOUND}</td>
                                </tr>
                            }
                           { timesheetShiftList.map((item, index)  => {
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1; 
                              let event_start_time = converDateToLocal(item.event_start_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                              let event_end_time = converDateToLocal(item.event_end_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                              let total_scheduled_hours = convertDecimalToHHMM(item.total_scheduled_hours); 
                              let total_over_time_hours = convertDecimalToHHMM(item.total_over_time_hours); 
                                    return (
                                       <React.Fragment key={index}>
                                          <tr className={item.isExpand?'shown':''} onClick={(e) => this.onLoadShift(e, item.crew_profile_id,item.isExpand)}>
                                             <td className="details-control sorting_1" ></td>
                                             <td>{indeNum}</td>
                                             <td></td>
                                             <td>{item.crew_profile_name}</td>
                                             {/*<td></td>*/}
                                             <td></td>
                                             <td>                                               
                                                
                                             </td> 
                                             <td>
                                                
                                             </td>
                                             <td className="text-center">{item.total_shifts}</td>
                                             <td className={this.state.isClientPage ? "hide" : "text-right"}>{profileCurrency} {parseFloat(item.total_pay).toFixed(2)}</td>
                                             <td className="text-center">{total_scheduled_hours}</td>
                                             {/*<td className="text-center"><p className="m-0">{convertDecimalToHHMM(item.total_actual_hours)}</p></td>*/}
                                             <td className="text-center">{total_over_time_hours}</td>
                                             <td></td>
                                             <td>                                               
                                            </td>
                                        </tr>    
                                       {  
                                          item.hasOwnProperty('shift') && item.shift.length>0?

                                          item.shift.map((shift, index2)  => {
                                             let shift_from_time = converDateToLocal(shift.from_time,timeZone.utc_offset,'ddmmyyyyhhmm');  
                                             let shift_to_time  = converDateToLocal(shift.to_time,timeZone.utc_offset,'ddmmyyyyhhmm');
                                             let checkin_datetime  = converDateToLocal(shift.checkin_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');      
                                             let checkout_datetime  = converDateToLocal(shift.checkout_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');      
                                             let scheduled_hours = convertDecimalToHHMM(shift.scheduled_hours); 
                                             let over_time = convertDecimalToHHMM(shift.over_time); 
                                             const scheduleShiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode)===Number(shift.schedule_status));
                                             let hideEdit = false; 
                                             if(this.state.isClientPage === true){
                                                hideEdit = true;
                                             }if(shift.oe_requested){
                                                hideEdit = false;
                                             } 
                                           return(
                                             <tr key={index+index2}>
                                             <td></td>
                                             <td></td>
                                             <td className="max-width-15 veritcal-alignment-text-top"><span className="change-count color-red text-bold special-shift-height">{shift.special_shift?"! ":""}</span></td>
                                             <td>{shift.is_crew_chief && <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>}{shift.shift_title + ' @ '+shift.event_title}
                                                <p><span className={"status "+scheduleShiftStatus[0].colorClass}><small className="status-fill">{scheduleShiftStatus[0].statusString}</small></span></p>
                                             </td>
                                             <td>{shift.shift_location[0].location.venue}<p></p></td>
                                             <td>
                                                {/* <Moment format="DD/MM/YYYY HH:mm">
                                                   {shift.from_time}
                                                </Moment>    */}
                                                {shift_from_time}
                                                <p className="m-0">  <small>  
                                                    {checkin_datetime}
                                                    </small>
                                                </p>                          
                                             </td> 
                                             <td>
                                                {/* <Moment format="DD/MM/YYYY HH:mm">
                                                   {shift.to_time}
                                                </Moment> */}
                                                {shift_to_time}
                                                <p className="m-0">  <small>  
                                                    {checkout_datetime}{item.cron_created?' (AUTO)':''}
                                                    </small>
                                                </p>      
                                             </td> 
                                             <td>
                                             </td>
                                             <td className={this.state.isClientPage ? "hide" : "text-right"}>
                                                {showStaffPayDetails(profileCurrency,supervisor,shift.crew_details)}

                                             </td>
                                             <td className="text-center">{scheduled_hours}</td>
                                             {/*<td className="text-center">{convertDecimalToHHMM(shift.actual_hours)}</td>*/}
                                             <td className="text-center">{over_time}{(shift.over_time_approval_status || shift.over_time>0) && <p><span className={shift.over_time_approval_status===1? "approved" : shift.over_time_approval_status===2?"rejected": shift.over_time>0? "pending-underline":""} onClick={shift.over_time_approval_status!==0? this.justClick:shift.over_time>0?(e) => this.editBtnClick(e, shift.id, shift.id, item.crew_profile_id, false, shift.invoice_sent) : this.justClick }></span></p>}</td>
                                             <td className="text-center">
                                                {shift.expenses.map((ite, index)  => {
                                                        return(
                                                         <p key={index} className={ite.approved===1?"p-content":"p-content color-red"}>{ite.expense && <small className={ite.approved===2?"strike-through":""}>{ite.expense.name} : {profileCurrency} {ite.amount}</small>}</p>
                                                        )

                                                })}
                                             </td>
                                             {/*<td className="text-center">{shift.invoice_sent===true?'Y':'N'}</td>*/}
                                             <td>
                                                <div className={shift.over_time_approval_status===0 && shift.over_time>0?"dropdown":hideEdit ?"hide" : "dropdown"} id={'dropdown-'+shift.id}>
                                                   <button className="dropdown-toggle" type="button"
                                                      id={'dropdownMenuButton-'+shift.id} data-toggle="dropdown"
                                                      aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, shift.id)}
                                                      >
                                                      <input type="image" id={"img-action-"+shift.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, shift.id)} ></input>
                                                   </button>
                                                   <div className="dropdown-menu" id={'dropdown-menu-'+shift.id}
                                                      aria-labelledby={'dropdownMenuButton-'+shift.id}>
                                                         <Link className="dropdown-item edit" to="#" onMouseDown={(e) =>  this.editBtnClick(e, shift.id, shift.id, item.crew_profile_id, false,shift.invoice_sent)}>{LBL_EDIT}</Link>
                                                         {/* <Link className="dropdown-item delete"
                                                         to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.crew_name)}>Delete</Link> */}
                                                   </div>
                                             </div>
                                            </td>
                                          </tr>     
                                           )
                                          }):<tr className="hide"></tr>
                                       }
                                       </React.Fragment>                                        
                                     )
                                  })      
                                }                      
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>              

               <ModalWindow ref={this.modal} setSelectCrewProfileId={this.setSelectCrewProfileId} selectCrewProfileId={this.state.selectCrewProfileId} header={LBL_EDIT_TIMESHEET} saveFormData={ (e)=>this.openConfirmModal(selectedTimesheetId)} resetModalForm={this.onModalFormReset} type={'save'} extra_field={''} onApproveOtChange ={this.onChangeApproveOT} approveChecked={approvedEventStatus} mark_absent={timesheetData.markAbsentStatus && !this.state.isClientPage ? 'markAbsent' : ''} onMarkAbsentChange={this.onMarkAbsentChange} markAbsentChecked={this.state.markAbsentChecked} viewHeading={false}>                  
                  <div className="row">
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_EVENT}</label>
                              <div className="text-input text-optional"><input name="event" type="text" placeholder="" value={timesheetData.event} disabled /></div>                              
                           </div>
                     </div> 
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_SHIFT_AND_SKILL}</label>
                              <div className="text-input text-optional"><input name="shift" type="text" placeholder="" value={timesheetData.shift} disabled /></div>                              
                           </div>
                     </div>
                  </div>  
                  <div className="row">
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_PERSON}</label>
                              <div className="text-input text-optional"><input name="person" type="text" placeholder="" value={timesheetData.person} disabled /></div>                              
                           </div>
                     </div>  
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_LOCATION}</label>
                              <div className="text-input text-optional"><input name="location" type="text" placeholder="" value={timesheetData.location} disabled /></div>                             
                           </div>
                     </div>
                  </div>    

                  <div className="row">
                     <div className="col-md-6">                  
                           <div className="form-group">
                                 <label>{LBL_CHECKIN_DATE_TIME}</label>
                                 <div className="row">
                                    <div className="col-md-6">
                                        <div className="calendar-input">
                                            <DatePicker 
                                                selected={selectedStartDate}
                                                onChange={selected =>this.onStartDateChange(selected)}
                                                name="startDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                // minDate={selectedStartDate}
                                                fixedHeight
                                                disabled={this.state.isClientPage}     
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="time-input">
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime', className:formErrors.startTime.length >0 ? "input-error" : '',disabled:this.state.isClientPage}}  value={  timesheetData.startTime} onChange={selected=>this.onHandleChangeStartTime(selected)} onBlur={selected=>this.onBlurStartTime(selected)} />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                     </div>
                     <div className="col-md-6">                    
                           <div className="form-group">
                                <label>{LBL_CHECKOUT_DATE_TIME}</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="calendar-input">
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                onChange={selected =>this.onEndDateChange(selected)}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                minDate={selectedStartDate} 
                                                fixedHeight
                                                disabled={this.state.isClientPage}  
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="time-input"> 
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', className:formErrors.endTime.length >0 ? "input-error" : '',disabled:this.state.isClientPage}}  value={  timesheetData.endTime} onChange={selected=>this.onHandleChangeEndTime(selected)}  onBlur={selected=>this.onBlurEndTime(selected)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                     </div> 
                  </div>   
                  
                  <div className="row">
                     <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_SHIFT_LENGTH_HOURS}</label>
                              <div className="text-input text-optional"><input name="shiftLength" type="text" placeholder="" value={timesheetData.shiftLength} disabled /></div>                             
                           </div>
                     </div>           
                  </div>      
                  <div className="row">
                     <div className="col-md-12">
                        {formErrors.totalHours.length >0 && (
                           <div className="text-red left-align text-12">{formErrors.totalHours}</div>
                        )} 
                     </div>  
                  </div>

                  <div className={this.state.isClientPage ? "row hide" : "row"}>
               {/* Normal crew pay details */}
                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_PAY_RATE_PER_HOUR}</label>
                              <div className="text-input"><input className={this.state.formErrors.pay_rate.length >0 ? "input-error" : ''} name="pay_rate" type="text" placeholder="" value={timesheetData.pay_rate} onChange={this.onHandleChange} /></div>                              
                           </div>
                     </div>
                     <div className="col-md-3">
                           <div className="form-group">
                              <label> {LBL_PAY_RATE_TOTAL} ({profileCurrency})</label>
                              <div className="text-input text-optional"><input name="pay_total" type="text" placeholder="" value={timesheetData.pay_total } disabled /></div>                              
                           </div>
                     </div>

                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_CHARGE_RATE_PER_HOUR}</label>
                              <div className="text-input"><input className={this.state.formErrors.charge_rate.length >0 ? "input-error" : ''} name="charge_rate" type="text" placeholder="" value={timesheetData.charge_rate} onChange={this.onHandleChange} /></div>                              
                           </div>
                     </div>
                     
                     <div className="col-md-3">
                           <div className="form-group">
                              <label> {LBL_CHARGE_RATE_TOTAL} ({profileCurrency})</label>
                              <div className="text-input text-optional"><input name="charge_total" type="text" placeholder="" value={timesheetData.charge_total } disabled /></div>                              
                           </div>
                     </div>
                  </div>
                  
                  <div className={(this.state.isClientPage || !timesheetData?.total_travel_cost) ? "row hide" : "row"} >  
                     <div className="col-md-6"> 
                           <div className="form-group">
                              <label>{LBL_SHIFT_TOTAL_TRAVEL_COST}</label>
                              <div className="text-input text-optional"><input name="total_travel_cost" type="text" placeholder="" value={timesheetData.total_travel_cost} disabled /></div>                      
                           </div>
                     </div>  
                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_DRIVER_PAY_RATE}</label>
                              <div className="text-input"><input className={((timesheetData?.total_travel_cost < (timesheetData.driver_pay_rate+timesheetData.passenger_pay_rate)) || (this.state.formErrors.driver_pay_rate.length > 0)) ? "input-error" : ''} name="driver_pay_rate" type="text" placeholder="" value={timesheetData.driver_pay_rate} onChange={this.onHandleChange} /></div>                      
                           </div>
                     </div>  
                     <div className="col-md-3">
                           <div className="form-group">
                              <label>{LBL_PASSENGER_PAY_RATE}</label>
                              <div className="text-input"><input className={((timesheetData?.total_travel_cost < (timesheetData.driver_pay_rate+timesheetData.passenger_pay_rate)) || (this.state.formErrors.passenger_pay_rate.length > 0)) ? "input-error" : ''} name="passenger_pay_rate" type="text" placeholder="" value={timesheetData.passenger_pay_rate} onChange={this.onHandleChange} /></div>                             
                           </div>
                     </div> 
                        
                  </div>  

                  <div className={"row padding-left-15  margin-top-10"}> 
                  <Accordion className="width-100-percent">
                     <Accordion.Toggle as={Nav} variant="link" eventKey="0" className={this.state.showOverTimeData!==true?'head-collp collapsed bgLightGreyed textPointer':'head-collp textPointer'} onClick={(e)=>this.accordionChange(e,'overtime')}>
                        <label>{LBL_OVER_TIME_HOURS}</label>
                     </Accordion.Toggle>
                     
                     <Accordion.Collapse eventKey="0">
                        <>
                        <div className="row"> 
                           <div className="col-md-6">
                              <div className="form-group">
                                 {/* <label>{' + '+LBL_OVER_TIME_HOURS} </label> */}
                                 {/* <div className="text-input"><input className={this.state.formErrors.overTimeHours.length >0 ? "input-error" : ''} name="overTimeHours" type="text" placeholder="" value={timesheetData.overTimeHours} onChange={this.onHandleChange} /></div>    */}
                                 <div className={'time-input'}>
                                 <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: LBL_SELECT, name:'overTimeHours', className:formErrors.overTimeHours.length >0 ? "input-error" : ''}}  value={timesheetData.overTimeHours === '' ? selectedoverTimeHours : timesheetData.overTimeHours} onChange={selected=>this.onHandleChangeoverTimeHours(selected)} timeConstraints={ ENUM_SHIFT_LENGTH_HHMM }/> 
                                 </div>   
                                 {this.state.otLengthError.length > 1 && <div className="text-red"><small>{this.state.otLengthError}</small></div>}                         
                              </div>
                           </div>
                           <div className="col-md-6">
                              {this.state.enableApprove && <div className="checkbox-wrapper">
                                  <div className="custom-radio">
                                      <input type="radio" id="radio1" name="radio" checked={approvedEventStatus===1?"checked":""} onChange={(e) => this.onChangeApproveOT(e,1)} />
                                      <label className="radio" htmlFor="radio1"></label>
                                      <label className="labeltext approve-color" htmlFor="radio1">{LBL_APPROVE}</label>
                                  </div>
                                  <div className="custom-radio">
                                      <input type="radio" id="radio2" name="radio" checked={approvedEventStatus===2?"checked":""} onChange={(e) => this.onChangeApproveOT(e,2)} />
                                      <label className="radio" htmlFor="radio2"></label>
                                      <label className="labeltext reject-color" htmlFor="radio2">{ LBL_REJECT}</label>
                                  </div>
                              </div>}
                           </div>
                        </div>
                        {!this.state.isClientPage && <div className="row margin-right-12"> 
                           <div className="col-md-3">
                              <div className="form-group">
                                 <label>{LBL_OT_PAY_RATE_PER_HOUR}</label>
                                 <div className="text-input"><input className={this.state.formErrors.over_time_pay_rate.length >0 ? "input-error" : ''} name="over_time_pay_rate" type="text" placeholder="" value={timesheetData.over_time_pay_rate} onChange={this.onHandleChange} /></div>                              
                              </div>
                           </div>
                           <div className="col-md-3">
                              <div className="form-group">
                                 <label> {LBL_OT_PAY_RATE_TOTAL} ({profileCurrency})</label>
                                 <div className="text-input text-optional"><input name="over_time_pay_total" type="text" placeholder="" value={timesheetData.over_time_pay_total } disabled /></div>                              
                              </div>
                           </div> 

                           <div className="col-md-3">
                              <div className="form-group">
                                 <label>{LBL_OT_CHARGE_RATE_PER_HOUR}</label>
                                 <div className="text-input"><input className={this.state.formErrors.over_time_charge_rate.length >0 ? "input-error" : ''} name="over_time_charge_rate" type="text" placeholder="" value={timesheetData.over_time_charge_rate} onChange={this.onHandleChange} /></div>                              
                              </div>
                           </div>
                        
                           <div className="col-md-3">
                              <div className="form-group timesheet-width">
                                 <label> {LBL_OT_CHARGE_RATE_TOTAL} ({profileCurrency})</label>
                                 <div className="text-input text-optional"><input name="over_time_charge_total" type="text" placeholder="" value={timesheetData.over_time_charge_total } disabled /></div>                              
                              </div>
                           </div>
                        </div>}
                        </>
                     </Accordion.Collapse>
                  </Accordion>   
                  </div>


                  <div className={"row padding-left-15  margin-top-10"}> 
                  <Accordion className="width-100-percent">
                     <Accordion.Toggle as={Nav} variant="link" eventKey="0" className={this.state.showOtherExpenseData!==true?'head-collp collapsed bgLightGreyed textPointer':'head-collp textPointer'} onClick={(e)=>this.accordionChange(e,'otherexpense')}> 
                        <label>{LBL_OTHER_EXPENSES}</label>
                     </Accordion.Toggle>
                     
                     <Accordion.Collapse eventKey="0">
                        <>
                        {/*<div className="row">
                           <div className="col-md-12">
                              <div className="form-group min-width-460">
                                 <div className="form-group multisel_textbox min-width-460">
                                    <div className='form-group select-input skills'>
                                       <CustomMultiSelect data={otherExpMultiListStaff}  onChange={selected =>this.onOtherExpDataChange(selected)} isFloat={true} isTextBox={true} isInputDescr={true} classValue={formErrors.otherExpCost.length >0 ? "input-error" : ''} />
                                    </div>
                                 </div> 
                              </div>
                           </div>  
                        </div>*/}
                        <div className="box-content">
                           <div className="table-responsive">
                              <table id="data-table" className="table" style={{width:"100%"}}>
                                  <thead>
                                      <tr>
                                          <th className="text-center">{LBL_SELECT}</th>
                                          <th className="text-center">{LBL_OTHER_EXPENSES}</th>
                                          <th className="text-center max-width-150">{LBL_AMOUNT}</th>
                                          <th className="text-center">{LBL_DESCRIPTION}</th>
                                          <th className="text-center">{LBL_FILE}</th>
                                          <th className="text-center">{LBL_APPROVE}</th>
                                      </tr>
                                  </thead>                                    
                                  <tbody> 
                                      {Array.isArray(otherExpMultiListStaff) && otherExpMultiListStaff.length===0 && <tr><td className="text-center" colSpan="6">{MSG_NOT_FOUND}</td></tr>}
                                      
                                      { Array.isArray(otherExpMultiListStaff) && otherExpMultiListStaff.map((item,index)  => {
                                             
                                      return (
                                          <tr key={index}>
                                              <td className="text-center">
                                                  <div className="custom-checkbox padding-right-0"><input type="checkbox" id={"select_"+item.value} name={"select_"+item.value} onChange={e => this.otherExpenseChange(e,index,item.value,0)} checked={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].select:false} />
                                                      <label className="checkbox" htmlFor={"select_"+item.value} ></label>
                                                   </div>
                                             </td>
                                              <td className="text-left">
                                                   <label>{item.label}</label>
                                              </td>
                                              <td className="text-center max-width-150">
                                                <div className="text-input"><input className={'grid-input '+ (formErrors.otherExpenseData[item.value] !== undefined ?  (formErrors.otherExpenseData[item.value] ? "input-error" : '') : '')} name={"amount_"+item.value} type="text" placeholder="" value={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].amount:''} onChange={e=>this.otherExpenseChange(e,index,item.value,0)} disabled={this.state.otherExpenseData[item.value]?false:true}/></div>                              
                                              </td>
                                              <td className="text-center">
                                                <div className="text-input"><input className={'grid-input width-100'} name={"desc_"+item.value} type="text" placeholder="" value={this.state.otherExpenseData[item.value]?this.state.otherExpenseData[item.value].desc:''} onChange={e=>this.otherExpenseChange(e,index,item.value,0)} disabled={this.state.otherExpenseData[item.value]?false:true}/></div>                              
                                              </td>
                                              <td className="text-center min-width-150">
                                                  {item.reciepts && 
                                                  item.reciepts.map(el => {
                                                      let ext = el.file.substr(el.file.lastIndexOf('.') + 1);
                                                     
                                                      return (
                                                      <div className="file-icon" key={el.id}>
                                                          <a href={el.file} target="_blank" rel="noopener noreferrer" style={{display:"inline"}}>
                                                          <FileIcon extension={ext} fold={true} 
                                                          radius={3} color="whitesmoke" {...defaultStyles[ext]}/>
                                                          </a>
                                                          {/*<span className=" remove-file" onClick=
                                                          {(e)=>this.removeDocFile(el.id,item.id,item.crew_skill_details===null?item.affiliate_document_details.name:item.crew_skill_details.affiliate_skill.certificate_name)}><i className="las la-minus"></i></span>*/}
                                                      </div>
                                                      )
                                                  })
                                                  }

                                              </td>
                                              <td className="text-center">
                                                <div className="checkbox-wrapper">
                                                    <div className="custom-radio">
                                                        <input type="radio" id={"approve_"+item.value+"1"} name={"approve_"+item.value+"1"} checked={!this.state.otherExpenseData[item.value]?'':this.state.otherExpenseData[item.value].approve===1?"checked":""} onChange={selected=>this.otherExpenseChange(selected,index,item.value,1)} disabled={this.state.otherExpenseData[item.value]?false:true} />
                                                        <label className="radio" htmlFor={"approve_"+item.value+"1"}></label>
                                                        <label className="labeltext approve-color" htmlFor={"approve_"+item.value+"1"}>{LBL_APPROVE} </label>
                                                    </div>
                                                    <div className="custom-radio">
                                                        <input type="radio" id={"approve_"+item.value+"2"} name={"approve_"+item.value+"2"} checked={!this.state.otherExpenseData[item.value]?'':this.state.otherExpenseData[item.value].approve===2?"checked":""} onChange={selected=>this.otherExpenseChange(selected,index,item.value,2)} disabled={this.state.otherExpenseData[item.value]?false:true} />
                                                        <label className="radio" htmlFor={"approve_"+item.value+"2"}></label>
                                                        <label className="labeltext reject-color" htmlFor={"approve_"+item.value+"2"}>{ LBL_REJECT}</label>
                                                    </div>
                                                </div>
                                              </td>
                                              
                                          </tr>    
                                          
                                      )
                                      })      

                                      }                      
                                    </tbody>
                                 </table>
                           </div>                            
                        </div> 
                        </>
                     </Accordion.Collapse>
                  </Accordion>   
                  </div>


                  {this.state.showOverTimeData!==true && <div className="row">&nbsp;</div>}

                     {/* <div className="text-input"><input className={this.state.formErrors.overTimeHours.length >0 ? "input-error" : ''} name="overTimeHours" type="text" placeholder="" value={timesheetData.overTimeHours} onChange={this.onHandleChange} /></div>    */}

                     {/* <div className={this.state.isClientPage ? "row hide" : "row"}>
                        <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_OVER_TIME_HOURS} </label>
                              
                              <div className={'time-input'}>
                              <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: LBL_SELECT, name:'overTimeHours', className:formErrors.overTimeHours.length >0 ? "input-error" : ''}}  value={timesheetData.overTimeHours === '' ? selectedoverTimeHours : timesheetData.overTimeHours} onChange={selected=>this.onHandleChangeoverTimeHours(selected)} timeConstraints={ ENUM_SHIFT_LENGTH_HHMM }/> 
                              </div>   
                              {this.state.otLengthError.length > 1 && <div className="text-red"><small>{this.state.otLengthError}</small></div>}                         
                           </div>
                        </div>
                     </div> */}


                     {/* OT crew pay details */}
                     {/* <div className={this.state.isClientPage ? "row hide" : "row"}>
                        
                        <div className="col-md-3">
                              <div className="form-group">
                                 <label>{LBL_OT_PAY_RATE_PER_HOUR}</label>
                                 <div className="text-input"><input className={this.state.formErrors.over_time_pay_rate.length >0 ? "input-error" : ''} name="over_time_pay_rate" type="text" placeholder="" value={timesheetData.over_time_pay_rate} onChange={this.onHandleChange} /></div>                              
                              </div>
                        </div>
                        <div className="col-md-3">
                              <div className="form-group">
                                 <label> {LBL_OT_PAY_RATE_TOTAL} ({profileCurrency})</label>
                                 <div className="text-input text-optional"><input name="over_time_pay_total" type="text" placeholder="" value={timesheetData.over_time_pay_total } disabled /></div>                              
                              </div>
                        </div>

                        <div className="col-md-3">
                              <div className="form-group">
                                 <label>{LBL_OT_CHARGE_RATE_PER_HOUR}</label>
                                 <div className="text-input"><input className={this.state.formErrors.over_time_charge_rate.length >0 ? "input-error" : ''} name="over_time_charge_rate" type="text" placeholder="" value={timesheetData.over_time_charge_rate} onChange={this.onHandleChange} /></div>                              
                              </div>
                        </div>
                        
                        <div className="col-md-3">
                              <div className="form-group timesheet-width">
                                 <label> {LBL_OT_CHARGE_RATE_TOTAL} ({profileCurrency})</label>
                                 <div className="text-input text-optional"><input name="over_time_charge_total" type="text" placeholder="" value={timesheetData.over_time_charge_total } disabled /></div>                              
                              </div>
                        </div>
                     </div> */}
                   

                  {/* <div className={timesheetData.markAbsentStatus && !this.state.isClientPage?"custom-checkbox":"hide"} ><input type="checkbox" id="markAbsent" name="markAbsent" onChange={this.onMarkAbsentChange} checked={this.state.markAbsentChecked}/><label className="checkbox" htmlFor="markAbsent"></label><label className="labeltext" htmlFor="markAbsent">{LBL_MARK_ABSENT}</label></div> */}
                  
               </ModalWindow>
               <ModalWindow ref={this.modalMarkAbsent} header="Confirm Mark Absent" type="confirm" deleteConfirmedItem={this.onMarkAbsent} resetModalForm={this.onModalAbsentReset} >
                  Are you sure you want to mark this crew as absent? This action cannot be undone.
               </ModalWindow>
            </div>
            <Filter isDetail={true}  onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}> 
               <FilterTimesheet selectedStartDate={this.state.selectedStartDate} selectedEndDate={this.state.selectedEndDate} setSelectedDate={this.setSelectedDate} actionNeeded={this.state.actionNeeded} defaultStartDate={this.state.defaultStartDate} defaultEndDate={this.state.defaultEndDate} filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} isClientPage={this.state.isClientPage} clientId={this.state.clientId} onShowFilterBy={this.onShowFilterBy} />

               <div>&nbsp;</div>

            </Filter>
         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      return {
        timesheet : state.timesheet.timesheet,     
        timesheetDetails:state.timesheet.timesheetDetails,   
        totalPage:state.timesheet.timesheetTotalPage,
        status:state.timesheet.status,
        activity:state.timesheet.activity,
        numRows:state.timesheet.timesheetNumRows,
        count:state.timesheet.timesheetCount,
        errorData:state.timesheet.errorData,
        isFilterOn: state.commons.isFilterOn,
        timesheetCSV:state.timesheet.timesheetCSV,
        timesheetSummaryCSV:state.timesheet.timesheetSummaryCSV,
        otherExps : state.event.otherExps, 
        subactivity : state.event.subactivity,
        getActionNeeded : state.timesheet.getActionNeeded,
        serverTimeList : state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        timesheetListAction:timesheetListAction,
        timesheetDetailsAction:timesheetDetailsAction,
        timesheetUpdateAction:timesheetUpdateAction,
        timesheetCSVDownloadAction:timesheetCSVDownloadAction,
        otherExpListAction:otherExpListAction,
        timesheetSummaryCSVDownloadAction:timesheetSummaryCSVDownloadAction,
        setActionNeeded:setActionNeeded,
        serverTimeAction:serverTimeAction,
        timeSheetDateHeader:timeSheetDateHeader,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(TimeSheetCrewBased);